import moment from 'jalali-moment'
import React from 'react'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
import input_vector_icon from 'assets/images/rectangle/input_vector.svg'
import output_vector_icon from 'assets/images/rectangle/output_vector.svg'
interface IItemProps {
    item: ICashinCashoutFinancial
}
export default function Item({ item }: IItemProps) {
    const isCashin = item.type.substring(0, 2) === 'cn'
    return (
        <div className=" bg-white rounded-[2px] mx-1.5 mb-[5px] p-3">
            <div className=" flex items-center justify-between">
                <p className=" text-base font-bold text-black">
                    {item.poolship_name}
                </p>
                {isCashin ? (
                    <span className=" inline-flex items-center gap-1.5 text-base font-bold text-green-1">
                        <img
                            className=" inline w-4 h-4 rounded-full p-0.5 bg-green-2"
                            src={input_vector_icon}
                            alt="cashin"
                        />
                        {item.amount.toLocaleString()} تومان
                    </span>
                ) : (
                    <span className=" inline-flex items-center gap-1.5 text-base font-bold text-error-3">
                        <img
                            className=" inline w-4 h-4 rounded-full p-0.5 bg-red-2"
                            src={output_vector_icon}
                            alt="cashout"
                        />
                        {item.amount.toLocaleString()} تومان
                    </span>
                )}
            </div>

            <div className=" flex items-center justify-between mt-2">
                <p className=" text-sm font-normal text-text-secondary">
                    {MoneyPoolTransactionTypes[item.type]}
                </p>
            </div>

            <div className=" h-px bg-divider my-2.5" />

            <div className=" flex items-center justify-between">
                <p className=" text-sm font-normal text-text-secondary">
                    {item?.jalali_time && ConvertJalaliDate(item.jalali_time)} |{' '}
                    <span className=" inline">
                        {moment
                            .from(
                                item.jalali_time,
                                'fa',
                                'jYYYY-jM-jD HH:mm:ss'
                            )
                            .format('HH:mm:ss')}
                    </span>
                </p>
            </div>

            {item.tag && (
                <>
                    <div className=" h-px bg-divider my-2.5" />
                    <p className=" text-sm font-normal text-text-body">
                        توضیحات: {item.tag}
                    </p>
                </>
            )}
        </div>
    )
}
